// App Loading Sequence
export enum LOADING_SEQUENCE {
  VS = "vehicle_selection",
  VS_DEALER = "vehicle_selection_dealer_locator",
  HOME = "home",
  HOME_NAME = "home_name_input",
  HOME_DEALER = "home_dealer_locator",
}

// Sidebar State
export enum SIDEBAR_CONTENT {
  DEFAULT = "",
  DEALER_LOCATOR = "dealer_locator",
  NAME_INPUT = "name_input",
  SHARE = "share",
  OFFERS = "offers",
}

// Email State
export enum EMAIL_VIEW {
  INITIAL = 0,
  INPUT = 1,
  SUCCESS = 2,
  ERROR = 3,
  PIN = 4,
}
